<template>
    <v-card
        max-width="375"
        class="mx-auto rounded-lg my-2"
        elevation="0"
    >
        <v-img
        :src="settings.profile_image ? settings.profile_image : ''"
        height="300px"
        dark
        gradient="to top, rgba(0,0,0,.8), rgba(0,0,0,.0), rgba(0,0,0,.0)"
        position="top center"
        color="primary"
        >
            <v-row class="fill-height ml-2" style="align-items:end;">
                <v-card-title class="white--text pl-1 py-0">
                <div class="font-weight-bold">
                    {{settings.profile_name}}
                </div>
                <div class="text--disabled" style="font-size:0.8em; line-height:1; width:100%;">{{settings.profile_job_title}}</div>
                </v-card-title>
            </v-row>
        </v-img>

        <v-card-text v-if="settings.profile_description">
            {{settings.profile_description}}
        </v-card-text>
        
        <v-list two-line>

            <v-list-item v-if="settings.profile_phone_number">
                <v-list-item-icon>
                <v-icon color="primary">
                    mdi-phone
                </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                <v-list-item-title>{{settings.profile_phone_number}}</v-list-item-title>
                <v-list-item-subtitle>Phone</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="settings.profile_email_address">
                <v-list-item-icon>
                <v-icon color="primary">
                    mdi-email
                </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                <v-list-item-title>{{settings.profile_email_address}}</v-list-item-title>
                <v-list-item-subtitle>Email</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    name: 'HostProfile',
    props: ['settings']
}
</script>
